export const NO_ACTIVE_OPERATION = 'none'; //indicates authentication process is not in progress
export const clearmePolicy = 'https://www.clearme.com/privacy-policy';
export const privacyPolicyLink =
  'https://www.t-mobile.com/content/digx/tmobile/us/en/privacy-center/privacy-notices/employee-contractor-privacy-notice.html';
export const msFormVerification = 'https://forms.office.com/r/kR9FsbeATz';
export const supportBridgeLink = 'https://t-mobile.webex.com/t-mobile/j.php?MTID=ma37fe4baefa70d6308b4ebca4a4be753';